import React, { Component } from 'react';
import { hours, minutes } from './options';
import './time-select.css'

class TimeSelect extends Component {
  constructor(props) {
    super(props);
    const time = (props.value || props.defaultValue).split(':');
    this.state = {
      hourValue: time[0],
      minuteValue: time[1],
    };
  }

  handleChange = (index, value) => {
    const { hourValue, minuteValue } = this.state;
    this.props.changeHandler(`${hourValue}:${minuteValue}:${minuteValue === '59' ? '59' : '00'}`);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState !== this.state) {
      this.handleChange();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value && nextProps.value) {
      const time = nextProps.value.split(':');
      this.setState({
        hourValue: time[0],
        minuteValue: time[1],
      })
    }
  }


  render() {
    const { hourValue, minuteValue } = this.state;
    return (
      <div className="select-time" style={this.props.style}>
        <select
          className="select-hour"
          value={hourValue}
          onChange={(ev) => {
            this.setState({ hourValue: ev.target.value });
          }}
        >
          {hours.map(hour => (
            <option key={hour} value={hour}>{hour}</option>
          ))}
        </select>
        <span className="select-time__colon">:</span>
        <select
          className="select-minute"
          value={minuteValue}
          onChange={ev => {
            this.setState({ minuteValue: ev.target.value });
          }}
        >
          {minutes.map(minute => (
            <option key={minute} value={minute}>{minute}</option>
          ))}
        </select>
      </div>
    );
  }
}

TimeSelect.propTypes = {};
TimeSelect.defaultProps = {};

export default TimeSelect;



// WEBPACK FOOTER //
// ./src/components/common/TimeSelect/TimeSelect.js